import { t } from "ttag";

import { useReferralCode } from "@/features/referral/hooks";
import { Banner, Button } from "@/shared/ui";

export const ReferralCodeBanner = () => {
  const {
    referralCode,
    actions: { shareCode },
  } = useReferralCode();

  return (
    <Banner.Root>
      <Banner.Header>
        <Banner.Label>{t`Your unique referral code`}</Banner.Label>
        <Banner.Title>{referralCode}</Banner.Title>
      </Banner.Header>

      <Banner.Actions>
        <Button size="lg" onClick={shareCode}>
          {t`Share`}
        </Button>
      </Banner.Actions>
    </Banner.Root>
  );
};
